import React from 'react';
import { I18n } from 'react-redux-i18n';

import Container, {
  Back,
  Row,
  Header,
  Picture,
  CompetitorTooltip
} from 'modules/Travel/components/DestinationPoint/container';
import Icon from 'components/Icon';
import Pellet from 'components/Pellet';
import Tooltip from 'components/Tooltip';

import { getStateToStatus } from 'utils/pos';

const renderStars = (value) => {
  let stars = '';
  for (let i = 0; i < value; i++) {
    stars += '★';
  }
  return stars;
};

const renderCompetitors = (data) => (
  <CompetitorTooltip>
    {Object.keys(data).map((item, index) => (
      <p key={index}>{item}</p>
    ))}
  </CompetitorTooltip>
);

const DestinationPoint = ({
  name,
  photo,
  network_code,
  state,
  dn_total,
  ws_award,
  client_refs_by_bottle,
  rival_wines,
  rivals_wines_by_brand,
  isBranded,
  stars,
  phone,
  email,
  address,
  store_type,
  handleCloseMarker,
  site
}) => (
  <Container>
    {photo && <Picture picture={photo} />}
    <Header>
      <Back hasPicture={photo} onClick={() => handleCloseMarker()}>
        <Icon icon="chevronLeft" />
      </Back>
      <div className="status">
        <Pellet
          size={'10px'}
          value={getStateToStatus(state)}
          square={network_code === 'OFF' ? true : undefined}
        />
        <p>
          {state === 'pos'
            ? I18n.t('travel.statusOptions.pos')
            : state === 'lost'
              ? I18n.t('travel.statusOptions.lost')
              : state === 'todo'
                ? I18n.t('travel.statusOptions.conquer')
                : I18n.t('travel.statusOptions.other')}
        </p>
      </div>
      <h1>{name}</h1>
      <div className="communication">
        <span className="social">
          <Tooltip placement="top" content={phone}>
            <a>
              <Icon className="phone" icon="phone" />
            </a>
          </Tooltip>
          <Tooltip placement="top" content={email}>
            <a
              href={email.startsWith('http') ? email : `mailto:${email}`}
              target="_blank"
              rel="noreferrer"
            >
              @
            </a>
          </Tooltip>
          <Tooltip placement="top" content={address}>
            <a>
              <Icon icon="localisationContainer" />
            </a>
          </Tooltip>
          <Tooltip placement="top" content={site}>
            <a href={site} target="_blank" rel="noreferrer">
              <Icon icon="world" />
            </a>
          </Tooltip>
        </span>
      </div>
    </Header>
    <div>
      {network_code === 'OFF' && store_type && (
        <Row>
          <div>
            <span>{I18n.t('travel.posDescription.typeCave')}</span>
            <p>{store_type}</p>
          </div>
        </Row>
      )}
      {stars && (
        <Row>
          <div>
            <span>
              {network_code === 'OFF'
                ? I18n.t('travel.posDescription.starCave')
                : I18n.t('travel.posDescription.starRestaurant')}
            </span>
            <p className="stars">{renderStars(stars)}</p>
          </div>
        </Row>
      )}
      {ws_award && network_code === 'ON' && (
        <Row>
          <div>
            <span>{I18n.t('travel.posDescription.award')}</span>
            <p>{ws_award}</p>
          </div>
        </Row>
      )}
      <Row>
        <div>
          <span>{I18n.t('travel.posDescription.countWine')}</span>
          <p>
            {dn_total} {I18n.t('travel.posDescription.countUnity')}
          </p>
        </div>
      </Row>
      {client_refs_by_bottle && client_refs_by_bottle.length > 0 && (
        <Row>
          <div>
            <span>
              {I18n.t('travel.posDescription.vintages')} (
              {Object.keys(client_refs_by_bottle).length})
            </span>
            <p className="dpVintagesList">
              {[
                ...new Set(
                  client_refs_by_bottle.map(
                    (item) => `${item.wine_name} ${item.vintage}`
                  )
                )
              ].join(', ')}
            </p>
          </div>
        </Row>
      )}
      {!isBranded && rival_wines && Object.keys(rival_wines).length > 0 && (
        <Row>
          <div>
            <span>
              {I18n.t('travel.posDescription.rivals')} (
              {Object.keys(rival_wines).length})
            </span>
            <p className="dpVintagesList">
              {Object.keys(rival_wines).join(', ')}
            </p>
          </div>
        </Row>
      )}
      {isBranded &&
        rivals_wines_by_brand &&
        Object.keys(rivals_wines_by_brand).length > 0 && (
          <Row className="competitors">
            <Tooltip
              placement="top"
              content={renderCompetitors(rivals_wines_by_brand)}
            >
              <div className="list">
                <div>
                  <span>{I18n.t('travel.posDescription.rivals')}</span>
                  <p>
                    {Object.keys(rivals_wines_by_brand).length}{' '}
                    {I18n.t('travel.posDescription.rivalsNumber')}
                  </p>
                </div>
                <div className="rightContent">
                  <Icon icon="chevronRight" />
                </div>
              </div>
            </Tooltip>
          </Row>
        )}
    </div>
  </Container>
);

export default DestinationPoint;
